export default __webpack_public_path__ + "static/hero-banner-video-40d59dcdbf77f73fcb1357a3bc2f7634.mp4";